enum TransactionEnrichmentType {
  LOAN_DOWN_PAYMENT = 'LOAN_DOWN_PAYMENT',
  TRANSFER_CREDIT = 'TRANSFER_CREDIT',
  TRANSFER_DEBIT = 'TRANSFER_DEBIT',
}

export default TransactionEnrichmentType;
